import script from "./EditOrDeleteButtons.vue?vue&type=script&setup=true&lang=ts"
export * from "./EditOrDeleteButtons.vue?vue&type=script&setup=true&lang=ts"

import "./EditOrDeleteButtons.vue?vue&type=style&index=0&id=8bc3fa88&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8bc3fa88"]])

export default __exports__